<template>
  <!-- Dynamically renders an ImageOverlayWrapper for videos (to show play icon) or a standard img for photos -->
  <component
    :is="isVideo ? ImageOverlayWrapper : 'img'"
    :src
    :alt
    draggable="false"
    loading="lazy"
    class="review-thumbnail"
    v-bind="
      isVideo
        ? {
            isWhite: true,
            iconProps: { icon: csgVideoControlPlay, size: 'l' },
          }
        : {}
    "
  />
</template>

<script setup lang="ts">
import { csgVideoControlPlay } from '@csgSvgIcons/icons';
import ImageOverlayWrapper from '~/components/common/Media/ImageOverlay/ImageOverlayWrapper.vue';

type ReviewThumbnailProps = {
  src: string;
  alt: string;
  isVideo?: boolean;
};

const { src, alt, isVideo = false } = defineProps<ReviewThumbnailProps>();
</script>
<style lang="scss">
img.review-thumbnail {
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1;
  cursor: pointer;
  object-fit: cover;
}
</style>
